
import { combineReducers } from 'redux';
import { 
    ALERT_CREATED,
    CART_CLEARED, CART_PRODUCT_ADDED, CART_PRODUCT_REMOVED,
    EVENT_CREATED,
    ORG_LOADED, ORG_UPDATED,
    LOCATION_CREATED, LOCATIONS_LOADED, LOCATION_UPDATED,
    PRODUCT_CREATED, PRODUCTS_LOADED, PRODUCT_UPDATED,
    USER_LOGGEDIN, USER_LOGGEDOUT
} from './actions';

// generic sort comparer
function compareName(a,b) {

    var aName = a.Name;
    var bName = b.Name;
  
    if (aName < bName)
      return -1;
    if (aName > bName)
      return 1;
    return 0;
}


function alerts(state = [], action) {
    
    switch (action.type) {
        case ALERT_CREATED:

            return action.alert;

        default:
            return state;
    }
}

function cart(state = [], action) {
    switch (action.type) {
        case CART_PRODUCT_ADDED:
            
            var i1 = state.slice();
            var alreadyInCart = false;
            for(var i = 0; i < i1.length; i++) {
                if(action.product.id === i1[i].id) {
                  i1[i] = action.product;
                  alreadyInCart = true;
                  break;
                }
            }

            if(!alreadyInCart)
                i1.push(action.product);

            return i1;

        case CART_PRODUCT_REMOVED:
            var i2 = state.slice();
            for(var j = 0; j < i2.length; j++) {
                if(action.product.id === i2[j].id) {
                  i2.splice(j, 1);
                  break;
                }
            }
            return i2;

        case CART_CLEARED:
            return [];
            
        default:
            return state;
    }
}

function events(state = [], action) {
    
    switch (action.type) {
        case EVENT_CREATED:

            return action.event;

        default:
            return state;
    }
}

function products(state = [], action) {
    
    switch (action.type) {
        case PRODUCT_CREATED:

            state.push(action.product);
            return state.sort(compareName);

        case PRODUCTS_LOADED:

            return action.products;

        case PRODUCT_UPDATED:

            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.product.id) {
                    state[i] = action.product;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}

function org(state = null, action) {
    
    switch (action.type) {
        case ORG_LOADED:

            return {
                id: action.org.id,
                name: action.org.name,
                description: action.org.description,
                website: action.org.website,
                latitude: action.org.latitude,
                longitude: action.org.longitude
            }

        case ORG_UPDATED:

            return {
                id: action.org.id,
                name: action.org.name,
                description: action.org.description,
                website: action.org.website,
                latitude: action.org.latitude,
                longitude: action.org.longitude,
                stripeCredentials: action.org.stripeCredentials
            }

        default:
            return state;
    }
}

function locations(state = [], action) {

    switch (action.type) {
        
        case LOCATION_CREATED:
            state.push(action.location);
            return state.sort(compareName);

        case LOCATIONS_LOADED:
            return action.locations;

        case LOCATION_UPDATED:
            for(var i = 0; i < state.length; i++) {
                if(state[i].id === action.location.id) {
                    state[i] = action.location;
                    break;
                }                
            }
            return state.sort(compareName);

        default:
            return state.sort(compareName);
    }
}



function user(state = {authenticated: false}, action) {

    switch (action.type) {
        case USER_LOGGEDIN:
            
            return {
                    authenticated: true,
                    id: action.user.id,
                    email: action.user.email,
                    firstName: action.user.firstName,
                    lastName: action.user.lastName,
                    orgId: action.user.orgId,
                    userType: action.user.userType,
                    gradeLevel: action.user.gradeLevel,
                    schoolID: action.user.schoolID,
                    school: action.user.school
                }

        case USER_LOGGEDOUT:

            return {
                authenticated: false
            }

        default:
            return state;
    }
}

const Reducers = combineReducers({ 
    alerts,
    cart,
    events,
    locations,
    org, 
    products,
    user 
})

const appState = (Reducers)

export default appState



// WEBPACK FOOTER //
// ./src/redux/reducers.js